import Icon from '../components/Icon.vue'

Icon.register({"less-than":{"width":384,"height":512,"paths":[{"d":"M365.5 357.7L147 255.9 365.5 154C381.5 146.5 388.5 127.5 381 111.5L367.5 82.5C360 66.5 341 59.5 324.9 67L18.5 209.9A32-32 0 0 1 0 238.9V273.1C0 285.6 7.2 296.9 18.5 302.1L324.8 445C340.9 452.5 359.9 445.5 367.4 429.5L381 400.4C388.5 384.3 381.5 365.2 365.5 357.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/less-than.js
// module id = null
// module chunks = 